<div id="snapshotPdf" class="flex flex-col gap-2 f-s-12" style="max-width: 1000px; font-size: 12px; line-height: 1.5; word-wrap: break-word; overflow-wrap: break-word; word-break: break-word; zoom: reset; -webkit-text-size-adjust: 100%; -moz-text-size-adjust: 100%; text-size-adjust: 100%;">
  <mat-card>
    <mat-card-title>
      <div class="flex flex-row gap-6"><strong>License type:</strong>Facilitator</div>
      <div><strong>License ID:</strong>&nbsp;&nbsp;&nbsp;&nbsp;{{license.licenseId}}</div>
      <div><strong>Date of application submission:</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{license.applicationDate}}</div>
      <div><strong>Renewal number:</strong>&nbsp;&nbsp;&nbsp;&nbsp;{{license.renewalCount}}
      </div>
    </mat-card-title>
  </mat-card>

  <mat-card>
    <mat-card-title>
      Getting Started Page
    </mat-card-title>
    <mat-card-content class="flex flex-col gap-4">
      <div style="padding-top: 2em" class="flex flex-col lg:flex-row gap-3">
            <span *ngIf="!license.isRenewal">
              Thank you for your interest in applying for a psilocybin facilitator license
              through the Oregon Psilocybin Services - Training Program, Licensing, and Compliance system (TLC).
            </span>
            <span *ngIf="license.isRenewal">
              Thank you for your interest in applying to renew your psilocybin Facilitator License through the Oregon Psilocybin Services - Training Program, Licensing, and Compliance system (TLC).
            </span>
      </div>
      <br>
      <div class="flex flex-col" *ngIf="!license.isRenewal">
        <span class="strong">Facilitator License Requirements:</span>
        <ul>
        <li>Must be 21 years of age or older
        </li>
        <li>Must have a high school diploma (or equivalent)
        </li>
        <li *ngIf="!sharedService.isAfterJan1st2027()">Must complete a facilitator training program with curriculum that has been approved by OPS
        </li>
        <li *ngIf="sharedService.isAfterJan1st2027()">Must complete a facilitator training program with curriculum that has been approved by OPS or by a training program that meets or exceeds OPS curriculum approval
        </li>
        <li>Must pass the OPS Regulations Exam
        </li>
        <li>Must pass a criminal background check
        </li>
        <li>Must pay a license application fee
        </li>
        <li>Must pay an annual license fee
        </li>
        </ul>
      </div>

      <div class="flex flex-col lg:flex-row gap-3" *ngIf="license.isRenewal">
          <div class="flex flex-col gap-2">
            <span class="strong">
              Applicants must read, understand, and agree to adhere to the Oregon Psilocybin Services Revised Statutes ORS 475A,
              Oregon Administrative Rules (OAR) Chapter 333, Division 333, as well as any other applicable statutes or laws.
            </span>
          </div>
      </div>

      <br>

      <span *ngIf="!license.isRenewal">
        <div class="flex flex-col"  >
          <span class="strong">The completed application packet contains the following:</span>

          <ul>
            <li>Completed and signed facilitator license application
            </li>
            <li>Uploaded copy of the front and back of a valid, unexpired government-issued photo identification for the applicant
            </li>
            <li *ngIf="!sharedService.isAfterJan1st2027()">Uploaded certificate of completion from a psilocybin facilitator training program with OPS approved curriculum
            </li>
            <li *ngIf="sharedService.isAfterJan1st2027()">Uploaded certificate of completion from psilocybin facilitator training programs with OPS approved curriculum or by an out of state training program that meets or exceeds OPS curriculum. Currently the only other state that meets or exceeds OPS curriculum is the State of Colorado
            </li>
            <li>Uploaded copy of the applicant's social equity plan
            </li>
            <li>A passing score of 75 percent or better on the OPS administered exam
            </li>
            <li><strong>$150</strong>&nbsp;Non-refundable facilitator license application fee paid and cleared
            </li>
          </ul>
        </div>

        <div style="padding-top: 2em" class="flex flex-row">
          <div class="flex flex-col gap-2">
            <strong>Important Notes: </strong>
            <ul>
              <li>Please review each section of the application to ensure it is complete
              </li>
              <li>Toward the end of the application, a fee page will describe how to submit the application fee which may be paid online or in-person
              </li>
              <li>
                OPS will not review an application packet until the application fee is paid and cleared.
                You have 90 days from the date of application submission to pay the application fee or it will be closed.
              </li>
              <li>
                <strong>Incomplete and Insufficient Application Statuses:</strong>&nbsp;&nbsp;&nbsp;
              </li>
            </ul>

            <div style="padding-left: 1em;" class="flex flex-col gap-2">
              <ul>
                <li *ngIf="showNewIncompleteDates(license.applicationDate)">
                  Incomplete: An application is considered incomplete if the application is missing required information
                  (e.g., the application fee has not been paid or the applicant did not submit fingerprints).
                  If the application is incomplete, we will notify you by email to give you an opportunity to make your application complete.
                  You have 30 days from the initial date you are notified to complete your application. If you fail to do so, the application will be closed.
                </li>
                <li *ngIf="showNewIncompleteDates(license.applicationDate)">
                  Insufficient: An application is considered insufficient if the complete application or site inspection
                  does not meet requirements outlined in statute or rule. If the application is insufficient,
                  we will notify you by email to give you an opportunity to meet requirements.
                  You will have 30 days from the initial date you are notified to meet requirements, or your application will be denied.
                </li>
                <li *ngIf="!showNewIncompleteDates(license.applicationDate)">Incomplete: An application is considered incomplete if the application is missing required information
                  (e.g., the application fee has not been paid or the applicant did not submit fingerprints).
                  If the application is incomplete, we will notify you by email to give you an opportunity to make your application complete.
                  You have 90 days from the initial date you are notified to complete your application. If you fail to do so, the application will be closed.
                </li>
                <li *ngIf="!showNewIncompleteDates(license.applicationDate)">Insufficient: An application is considered insufficient if the complete application or site inspection
                  does not meet requirements outlined in statute or rule. If the application is insufficient,
                  we will notify you by email to give you an opportunity to meet requirements.
                  You will have 90 days from the initial date you are notified to meet requirements, or your application will be denied.
                </li>
              </ul>
            </div>

          </div>
        </div>

        <div style="padding-top: 2em" class="flex flex-col gap-2">
          <span>
            <span class="strong">When you click the continue button at the bottom of this page, you will proceed to the psilocybin<br/> facilitator license application.</span> &nbsp;&nbsp;&nbsp;
            <br>The application automatically saves in TLC. You may exit the application and come back later to complete and submit the application, if needed.
          </span>
        </div>
      </span>

      <span *ngIf="license.isRenewal">
        <div style="padding-top: 2em" class="flex flex-col lg:flex-row gap-3">
             <div class="flex flex-col gap-2">
               <span class="strong">A completed renewal application packet contains the following:</span>
               <ul>
                 <li>Completed and signed facilitator license renewal application</li>
                 <li>Uploaded evaluation of last year's Social Equity Plan</li>
                 <li>Uploaded copy of the &nbsp;&nbsp;&nbsp;<strong><i>front and back</i></strong>&nbsp;&nbsp;&nbsp; of a valid, unexpired government-issued photo identification</li>
               </ul>
             </div>
            </div>

          <div style="padding-top: 2em" class="flex flex-row">
            <div class="flex flex-col gap-2">
              <strong>Important Notes: </strong>
              <ul>
                <li>Please review each section of the application to ensure it is complete</li>
                <li>Toward the end of the renewal application, a fee page will describe how to submit the renewal license fee which may be paid online, by mail or in-person</li>
              </ul>
              <br>

              <strong>Renewal: </strong>
              <span class="p-l-24">
                <strong>Timely Renewal Applications:</strong>
              </span>
              <span class="p-l-24">
                To be considered a timely renewal under OAR 333-333, renewal applications must be complete, meet all submission requirements, and be
                submitted at least 60 days before the license expiration date. The TLC system will open 120 days before the license expires to allow licensees to apply for the renewal license.
              </span>
              <span class="p-l-24">
                If a timely application is submitted, licensees may continue to operate after the license expires, provided OPS has not yet processed the renewal. Incomplete renewal applications
                will not be considered timely unless all required information is submitted at least 60 days before the expiration date.
              </span>
              <span class="p-l-24">
                <strong>Important:</strong> If your renewal application fee does not clear 30 days after your renewal application is moved to “Renewal approved, pending fee payment and clearance”
                status, your renewal application will be closed. If your license has expired, you will no longer be able to exercise the privileges of the license upon expiration.
              </span>
              <span class="p-l-24">
                You are welcome to re-apply for an OPS license in the future through the TLC system or by mail. To re-apply, you will have to complete the application process, pay the application and license fee, and
                complete a new background check, along with all other requirements of licensure.
              </span>

              <span class="flex-1"></span>

              <span class="p-l-24">
                <strong>Untimely  Renewal Applications:</strong>
              </span>
              <span class="p-l-24">
                Under OAR 333-333, any renewal applications submitted fewer than 60 days prior to the license expiration date are considered untimely.
              </span>
              <span class="p-l-24">
                Per ORS 333-333, licensees who submit untimely applications may not continue to operate if OPS is unable to process the untimely renewal before the license expires. In such cases, all licensed
                activities must cease as of the expiration date until the renewal is approved and a new license is issued.
              </span>
              <span class="p-l-24">
                <strong>Important:</strong> If your renewal payment does not clear within 30 days of your renewal application being moved to “Renewal approved, pending fee payment and clearance” status, your
                renewal application will be closed. If your license has expired, you will no longer  be able to exercise the privileges of the license upon expiration.
              </span>
              <span class="p-l-24">
                You are welcome to re-apply for an OPS license in the future through the TLC system or by mail. To re-apply, you will have to
                complete the application process, pay the application and license fee, and complete a new background check, along with all other requirements of licensure.
              </span>
            </div>
          </div>

          <div style="padding-top: 2em" class="flex flex-col gap-2">
            <span>
              <span class="strong">When you click the continue button at the bottom of this page, you will proceed to the psilocybin facilitator license application.</span>
              <br>The renewal automatically saves in TLC. You may exit the application and come back later to complete and submit the renewal application, if needed
            </span>
          </div>
      </span>


          <div style="padding-top: 2em;" class="flex flex-col gap-2">
            <span>
              <strong>DISCLAIMER:</strong> &nbsp;&nbsp;&nbsp;
              Psilocybin remains a schedule I drug under the federal Controlled Substances Act.
              Applicants are responsible for making their own determinations regarding the legal risks associated with participating in this program.
              The information you provide in your application materials, including applicant name, is subject to disclosure under Oregon's public records laws.
            </span>
          </div>
    </mat-card-content>

    <div class="page-break"></div>

    <mat-card-title>
      Applicant Information Page
    </mat-card-title>
    <mat-card-content class="flex flex-col gap-4">


      <div *ngFor="let applicant of license.applicants" class="p-b-16">
      <div><strong>Applicant Information</strong></div>
      <h3><i><u>{{applicant.legalFirstName}} {{applicant.legalLastName}}</u></i></h3>

      <div class="flex flex-col">
        <span><strong>Legal Name</strong></span>
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>First</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].legalFirstName}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>Last</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].legalLastName}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>Middle</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].legalMiddleName}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Preferred Name</strong></span>
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>First</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].preferredFirstName}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>Last</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].preferredLastName}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>Middle</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].preferredMiddleName}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Prior names and aliases</strong></span>
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>This information is used for the purposes of the background check</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].alternateNames}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Date of Birth</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].dob | date}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col mt-4">
        <div><strong>*SOCIAL SECURITY NUMBER DISCLOSURE:</strong></div>
        <ul>
          <li>
            As part of your application for an initial or renewal license, Federal and State laws require you to provide your
            Social Security Number (SSN),
            if you have one, to Oregon Psilocybin Services for child support enforcement purposes (42 USC § 666(a)(13) & ORS
            25.785).
            If you are an applicant or licensee and you have an SSN but fail to provide your SSN, Oregon Psilocybin Services may
            refuse to process your application.
            Your SSN will be used only for child support enforcement purposes unless you confirm your agreement that OPS can use
            it for administrative purposes
            as well.
          </li>
        </ul>

        <div>
          <strong>IMPORTANT NOTE: If you do not have a social security number, you may still be licensed or permitted by<br/> Oregon Psilocybin Services. </strong>&nbsp;&nbsp;&nbsp;
        </div>
        <ul>
          <li>
            Based on our authority under OAR 333-333-4100, we are requesting your voluntary consent to use your SSN for the
            following administrative purposes only:
            to positively confirm your identity during the criminal records check. Oregon Psilocybin Services will not deny you
            any rights, benefits or privileges
            otherwise provided by law if you do not consent to use of your SSN for these administrative purposes (5 USC§
            552(a)).
            <strong>Please check the appropriate box next to the social security field indicating whether you consent<br/> or do not
              consent.</strong>
            </li>
        </ul>

      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>SSN</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].ssn}}</span>
            </div>
            <span>
              <span class="k-icon"  [ngClass]="license.applicants[0].noSSN ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">I don't have a social security number</span>
            </span>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Do you consent to use of SSN for purposes of confirming identity during a criminal records check?</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].ssnAttestation ? 'Yes' : 'No'}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="p-t-16 flex flex-row gap-4" *ngIf="license.isRenewal">
        <div class="flex flex-col gap-2">
          <span><strong>Since the last time you applied for a license/renewal have you had any updates to your convictions history related to misdemeanors or felonies?</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{license.applicants[0].changeInConvictionHistory ? 'Yes' : 'No'}}</span>
          </div>
          <span *ngIf="license.isRenewal">Oregon Background Check Unit provides background checks for OPS. We will reach out if additional background check work is required.</span>
        </div>
      </div>

      <span class="strong">*For purposes of these questions, “license” means any professional or occupational license, permit or certification that authorizes an individual
                to engage in an occupation or business, issued by a local, state, or tribal governmental entity, or by a governmental body in another country.
      </span>

      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span class="strong">In the last 10 years, have you held a license in Oregon or in another state or country? If yes, please describe the type of license, what state or country it was issued in,
            and provide dates that the license was in effect</span>
          <div class="flex flex-row gap-2">
            <span>{{license.applicants[0].heldLicense ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>

      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Previous Licenses Held</strong></span>
          <div class="flex flex-row gap-2">
            <span class="text-wrap">{{license.applicants[0].licensesHeld}}</span>
          </div>
        </div>
      </div>

      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span class="strong">In the last 10 years, have you been denied a license? If yes, please upload documentation explaining why and provide all relevant information.</span>
          <div class="flex flex-row gap-2">
            <span>{{license.applicants[0].deniedLicense ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>

      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span class="strong">For any license you have held, have you been subject to discipline by the entity that issued the license or had the license suspended or revoked in the last 10 years?
                      If so, please upload documentation explaining the reasons for the discipline or revocation and provide all relevant documentation.</span>
          <div class="flex flex-row gap-2">
            <span>{{license.applicants[0].subjectToDiscipline ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>

      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span class="strong">In the last 10 years, have you been sued for money damages related to work you provided under a license? If yes, please upload documentation to explain and provide all relevant documentation.</span>
          <div class="flex flex-row gap-2">
            <span>{{license.applicants[0].suedForDamages ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>

      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span class="strong">In the last 10 years, have you settled allegations or claims against you related to a license? If so, please upload documentation to explain and provide all relevant documentation.</span>
          <div class="flex flex-row gap-2">
            <span>{{license.applicants[0].settledAllegations ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>

      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span class="strong">Has anyone ever alleged that you abused a child or an adult? If you answered yes, please upload documentation to explain the events and provide all relevant documentation.</span>
          <div class="flex flex-row gap-2">
            <span>{{license.applicants[0].allegedAbuse ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>

      <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].allegedAbuse">
        <div class="flex flex-col gap-2">
          <span class="strong">Was the allegation substantiated? If you answered yes, please upload documentation to explain the events and provide all relevant documentation.</span>
          <div class="flex flex-row gap-2">
            <span>{{license.applicants[0].substantiatedAllegation ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>

      <h3>Contact Information</h3>
      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Primary Phone</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].phone}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>Alternate Phone</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].alternatePhone}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Primary Email Address</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].email}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>Confirm Email Address</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].email}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Preferred Language</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].language}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Other OPS Licenses or Permits</strong></span>
            <div class="flex flex-row gap-2">
              <span>
                <span class="k-icon"  [ngClass]="license.applicants[0].previousLicense ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                <span class="text-wrap">Check the box if the applicant applied for or received any other licenses or permits from Oregon Psilocybin Services</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].previousLicense">
          <div class="flex flex-col gap-2">
            <span><strong>Please provide the license id(s) for each Oregon Psilocybin Services license.</strong></span>
            <div class="flex flex-row gap-2">
              <span class="text-wrap">{{license.applicants[0].affiliatedLicenses}}</span>
            </div>
          </div>
        </div>
      </div>

      <h3>Required 303 Applicant and Licensee REAL & SOGI Data</h3>
      <div class="flex flex-col gap-2">
        <span>Senate Bill 303 (SB 303) was adopted by the Oregon Legislature in 2023 and is now codified in ORS 475A.372 and ORS 475A.374. SB 303 requires Oregon Psilocybin Services (OPS) to collect and compile information about OPS license applicants and licensees. The 303 Applicant Data is kept separate from your application materials and will not be used to make any decisions related to your license application.
        </span>
        <span>All initial and renewal applicants are required to click the link below and complete the questions as part of the OPS application process: </span>
        <a routerLink="/applicant-data"  target="_blank">https://psilocybin.oregon.gov/applicant-data</a>
        <span>By signing below, the applicant hereby attests and confirms that:</span>
        <ul>
          <li>The Required 303 Applicant and Licensee REAL & SOGI Data form has been completed and submitted in accordance with applicable Oregon Administrative Rules (OAR).</li>
          <li>The information provided on the Required 303 Applicant and Licensee REAL & SOGI Data form is true, accurate, and complete to the best of the applicant's knowledge at the time of submission.</li>
          <li>The applicant understands that submission of this form is a required component of the licensure or application process under ORS Chapter 475A and applicable to OAR 333-333.</li>
          <li>The applicant acknowledges that providing false information may result in administrative penalties.</li>
        </ul>
        <span>Signature: {{license.applicants[0].realSogiSignature}}</span>
        <span>Date 303 Applicant and Licensee REAL & SOGI Data form was submitted: {{license.applicants[0].realSogiDate | date}}</span>
      </div>

      <h3>Address</h3>
      <h3>Physical Address</h3>
      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Street Apt/Unit/Suite</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].physicalStreet}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>City</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].physicalCity}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span class="strong">State/US territory/freely associated state</span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].physicalState}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-6">
          <div class="flex flex-col gap-2">
            <span><strong>Zip</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].physicalZip}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>County</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].physicalCounty}}</span>
            </div>
          </div>
        </div>
      </div>

      <h3>Mailing Address</h3>
      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-3">
          <div class="flex flex-col gap-2">
            <div class="flex flex-row gap-2">
              <span>
                <span class="k-icon"  [ngClass]="license.applicants[0].mailingIsPhysical ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                <span class="text-wrap">Same as Physical</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!license.applicants[0].mailingIsPhysical" class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-6">
          <div class="flex flex-col gap-2">
            <span><strong>Street Apt/Unit/Suite</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].mailingStreet}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>City</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].mailingCity}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span class="strong">State/US territory/freely associated state</span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].mailingState}}</span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!license.applicants[0].mailingIsPhysical" class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Zip</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].mailingZip}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>County</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.applicants[0].mailingCounty}}</span>
            </div>
          </div>
        </div>
      </div>

      <br>

      <div class="flex flex-col">
        <div class="m-t-8 flex flex-row">
          <div class="flex flex-col gap-3">
            <span><strong >Residential history outside of Oregon in the past 5 years</strong></span>
            <span>*This information is used for the purposes of the background check.</span>
            <span>*City, state, country, from month/year to month/year.</span>
            <div class="flex flex-row" *ngFor="let residence of applicant.residentialHistory">
              <div class="flex flex-row gap-1">
                <span>{{residence.city}}</span>
                <span>{{residence.state}},</span>
                <span>{{residence.country}}</span>
                <span class="m-l-8"><strong>From:</strong></span>
                <span>{{residence.from | date: 'MMM, yyyy'}}</span>
                <span class="m-l-8"><strong>To:</strong></span>
                <span>{{residence.to | date: 'MMM, yyyy'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="sharedService.isAfterJan1st()">
        <h3>Are you licensed by the boards listed below?</h3>

        <div class="flex flex-col gap-4" *ngIf="sharedService.isAfterJan1st2027()">
          <span class="text-wrap"><strong>The Occupational Therapy Licensing Board</strong></span>
          <span>{{license.applicants[0].occupationalTherapyLicensingBoard ? 'Yes' : 'No'}}</span>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].occupationalTherapyLicensingBoard">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>License Number</strong></span>
              <span class="text-wrap">{{license.applicants[0].occupationalTherapyLicensingBoardLicenseNumber}}</span>
            </div>
          </div>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].occupationalTherapyLicensingBoard">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>Expiration date of license</strong></span>
              <span class="text-wrap">{{license.applicants[0].occupationalTherapyLicensingBoardExpirationDate | date}}</span>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <span class="text-wrap"><strong>The Oregon Board of Licensed Professional Counselors and Therapists</strong></span>
          <span>{{license.applicants[0].boardOfLicensedCounselors ? 'Yes' : 'No'}}</span>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfLicensedCounselors">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>License Number</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfLicensedCounselorsLicenseNumber}}</span>
            </div>
          </div>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfLicensedCounselors">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>Expiration date of license</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfLicensedCounselorsExpirationDate | date}}</span>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <span class="text-wrap"><strong>The Oregon Board of Naturopathic Medicine</strong></span>
          <span>{{license.applicants[0].boardOfNaturopathic ? 'Yes' : 'No'}}</span>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfNaturopathic">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>License Number</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfNaturopathicLicenseNumber}}</span>
            </div>
          </div>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfNaturopathic">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>Expiration date of license</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfNaturopathicExpirationDate | date}}</span>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-4" *ngIf="sharedService.isAfterJan1st2027()">
          <span class="text-wrap"><strong>The Oregon Board of Physical Therapy</strong></span>
          <span>{{license.applicants[0].boardOfPhysicalTherapy ? 'Yes' : 'No'}}</span>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfPhysicalTherapy">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>License Number</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfPhysicalTherapyLicenseNumber}}</span>
            </div>
          </div>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfPhysicalTherapy">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>Expiration date of license</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfPhysicalTherapyExpirationDate | date}}</span>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <span class="text-wrap"><strong>The Oregon Medical Board</strong></span>
          <span>{{license.applicants[0].medicalBoard ? 'Yes' : 'No'}}</span>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].medicalBoard">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>License Number</strong></span>
              <span class="text-wrap">{{license.applicants[0].medicalBoardLicenseNumber}}</span>
            </div>
          </div>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].medicalBoard">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>Expiration date of license</strong></span>
              <span class="text-wrap">{{license.applicants[0].medicalBoardExpirationDate | date}}</span>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <span class="text-wrap"><strong>The Oregon Board of Psychology</strong></span>
          <span>{{license.applicants[0].boardOfPsychology ? 'Yes' : 'No'}}</span>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfPsychology">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>License Number</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfPsychologyLicenseNumber}}</span>
            </div>
          </div>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfPsychology">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>Expiration date of license</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfPsychologyExpirationDate | date}}</span>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <span class="text-wrap"><strong>The Oregon State Board of Nursing</strong></span>
          <span>{{license.applicants[0].boardOfNursing ? 'Yes' : 'No'}}</span>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfNursing">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>License Number</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfNursingLicenseNumber}}</span>
            </div>
          </div>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfNursing">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>Expiration date of license</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfNursingExpirationDate | date}}</span>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <span class="text-wrap"><strong>The State Board of Licensed Social Workers</strong></span>
          <span>{{license.applicants[0].boardOfSocialWorkers ? 'Yes' : 'No'}}</span>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfSocialWorkers">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>License Number</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfSocialWorkersLicenseNumber}}</span>
            </div>
          </div>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfSocialWorkers">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>Expiration date of license</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfSocialWorkersExpirationDate | date}}</span>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <span class="text-wrap"><strong>The State Board of Pharmacy</strong></span>
          <span>{{license.applicants[0].boardOfPharmacy ? 'Yes' : 'No'}}</span>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfPharmacy">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>License Number</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfPharmacyLicenseNumber}}</span>
            </div>
          </div>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.applicants[0].boardOfPharmacy">
            <div class="flex flex-col gap-2">
              <span class="text-wrap"><strong>Expiration date of license</strong></span>
              <span class="text-wrap">{{license.applicants[0].boardOfPharmacyExpirationDate | date}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-3">
        <div class="flex flex-row items-start">
          <span class="flex items-start gap-1">
              <span class="k-icon" [ngClass]="license.applicants[0].highSchoolDiploma ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">I certify I have a high school diploma or equivalent education as required by ORS 475A.325 (2)(d)</span>
          </span>
        </div>
      </div>

      <br>

      <div *ngIf="license.isRenewal" class="flex flex-col gap-4">
        <span class="text-wrap"><strong>Is all the information on this screen current and correct?</strong></span>
        <span class="text-wrap strong">Some information may be outdated or incorrect but you cannot change it on this application. These changes require
             additional documentation and possibly additional fees. These changes are made by a Change Request. If information is incorrect or outdated,
             please select "No," below and follow the instructions for a Change Request</span>
        <span>{{license.applicants[0].applicantPageCorrect ? 'Yes' : 'No'}}</span>

        <div class="p-t-16 flex flex-row gap-4" *ngIf="!license.applicants[0].applicantPageCorrect">
          <div class="flex flex-col gap-2" >
            <span class="text-wrap"><strong>Please list the information that is not current and correct</strong></span>

            <div class="flex flex-row gap-2">
              <span class="text-wrap">{{license.applicants[0].applicantPageCorrectReason}}</span>
            </div>
            <div class="text-wrap">You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section.
              This is the first page you see when you log into TLC.</div>
          </div>
        </div>
      </div>

      </div>
    </mat-card-content>

    <mat-card-content class="flex flex-col gap-4">
      <div><strong>Identity and Residency Verification Documents</strong></div>
      <div class="flex flex-col gap-2">
      <div>You must upload a copy of the &nbsp;&nbsp;&nbsp;<strong><i>front and back</i></strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;of a valid, unexpired government-issued photo identification. Accepted identification includes:</div>
      <ul>
        <li>Passport;</li>
        <li>Driver license, whether issued by the State of Oregon or by another state of the United States - &nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;&nbsp;&nbsp;;</li>
        <li>Identification card issued under ORS 807.400 - &nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;&nbsp;&nbsp;;</li>
        <li>United States military identification card - &nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;&nbsp;&nbsp;;</li>
        <li>An identification card issued by a federally recognized Indian tribe with photo, name and date of birth - &nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;&nbsp;&nbsp;; or</li>
        <li>Any other identification card issued by a state or territory that bears a picture of the person, the name of the person, the person's date of birth and a physical description of the person - &nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;&nbsp;&nbsp;</li>
      </ul>

      <br>

      <div>
        <h4>Current Documents</h4>
        <div>
          <div class="flex flex-row w-full">
            <span class="flex flex-col strong w-[40%]">File</span>
            <span class="flex flex-col strong w-[60%]">Requirement</span>
          </div>
          <div *ngFor="let applicant of license.applicants">
            <div *ngFor="let document of applicant.applicantDocuments" class="flex flex-row">
            <span class="flex flex-col w-[40%]">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
            <span class="flex flex-col w-[60%]">
              <span *ngFor="let type of document.types">
                <span *ngFor="let docType of documentTypes">
                  <span *ngIf="docType.id == type"> {{docType.type}} </span>
                </span>
              </span>
            </span>
            </div>
          </div>
        </div>
      </div>

    </div>
    </mat-card-content>

    <div class="page-break"></div>

    <mat-card-title>
      Documents Page
    </mat-card-title>
    <mat-card-content class="flex flex-col gap-4">
      <div><strong>
        <span *ngIf="!license.isRenewal">The following documentation is required to apply for a Psilocybin Facilitator License:</span>
        <span *ngIf="license.isRenewal">Upload the Following Documentation to Apply to Renew Your Psilocybin Facilitator License:</span>
      </strong></div>
      <div class="flex flex-col gap-2">
        <ul>
          <li *ngIf="!license.isRenewal && !sharedService.isAfterJan1st2027()">A copy of your certificate of completion from a psilocybin facilitator training program with an OPS approved curriculum</li>
          <li *ngIf="!license.isRenewal && sharedService.isAfterJan1st2027()"> A copy of your certificate of completion from a psilocybin facilitator training program with OPS-approved curriculum or by an out-of-state training program that meets or exceeds OPS curriculum. Currently the only other state that meets or exceeds OPS curriculum is the State of Colorado</li>
          <li *ngIf="license.isRenewal">Social Equity Plan Evaluation</li>
          <li *ngIf="license.isRenewal"><a href="https://www.oregon.gov/oha/PH/PREVENTIONWELLNESS/Documents/Continuing-Facilitator-Education-Hours-Log.pdf" target="_blank">OPS Continuing Facilitator Education Hours Log</a> AND proof of attendance
            <ul>
              <li>This form can be located on the <a href="https://www.oregon.gov/oha/PH/PREVENTIONWELLNESS/Pages/Oregon-Psilocybin-Services.aspx" target="_blank">OPS website</a></li>
              <li>A certificate or other proof of attendance is required from the training, conference, or organization you attended to verify the completion of your continuing education hours. This documentation must be submitted along with this form.</li>
            </ul>
          </li>
          <li *ngIf="license.isRenewal">Updated Social Equity Plan (not required)</li>
          <li *ngIf="license.isRenewal && !sharedService.isAfterJan1st2027()">A copy of your certificate of completion from a psilocybin facilitator training program with an OPS approved curriculum (not required)</li>
          <li *ngIf="license.isRenewal && sharedService.isAfterJan1st2027()">A copy of your certificate of completion from a psilocybin facilitator training program with OPS-approved curriculum or by an out-of-state training program that meets or exceeds OPS curriculum. Currently the only other state that meets or exceeds OPS curriculum is the State of Colorado. (not required)</li>
        </ul>

       </div>
      <div style="padding-left: 2em" class="flex flex-col" *ngIf="!sharedService.isAfterJan1st2027()">
        <ul>
        <li>Please note: the facilitator training program must have an OPS approved curriculum </li>
        </ul>
      </div>
      <ul>
        <li *ngIf="!license.isRenewal">Social Equity Plan</li>
        <li>If you are requesting a reduced licensing fee, please upload one of the following required supporting documents:</li>
      </ul>

      <div style="padding-left: 2em" class="flex flex-col">
        <ul>
        <li>A copy of a current monthly Supplemental Security Income benefit statement showing dates of coverage</li>
        <li>A copy of the applicant's current eligibility statement or card if enrolled in Oregon Health Plan</li>
        <li>A copy of current proof of food stamp benefits from the Oregon Supplemental Nutrition Assistance Program</li>
        <li>A copy of proof of having served in the Armed Forces, such as but not limited to, submitting a Veteran's Administration form DD-214</li>
        </ul>
      </div>

      <br>
      <div>
        <h4>Upload Supporting Documents</h4>
      </div>

      <div class="flex flex-col gap-2">
        <div>For each document select the requirements it verifies</div>
        <div class="p-t-8 flex flex-col gap-2">

          <div class="flex flex-col">
            <div>
              <span class="k-icon k-i-checkbox"></span>
              <span class="text-wrap">Training Certificate</span>
            </div>
            <div *ngIf="!license.isRenewal">
              <span class="k-icon k-i-checkbox"></span>
              <span class="text-wrap">Social Equity Plan</span>
            </div>
            <div *ngIf="license.isRenewal">
              <span class="k-icon k-i-checkbox"></span>
              <span class="text-wrap">Updated Social Equity Plan</span>
            </div>
            <div *ngIf="license.isRenewal">
              <span class="k-icon k-i-checkbox"></span>
              <span class="text-wrap">Social Equity Plan Evaluation</span>
            </div>
            <div *ngIf="license.isRenewal">
              <span class="k-icon k-i-checkbox"></span>
              <span class="text-wrap">Continuing Facilitator Education Hours Log AND proof of attendance</span>
            </div>
            <div>
              <span class="k-icon k-i-checkbox"></span>
              <span class="text-wrap">Reduced Fee</span>
            </div>
          </div>

        </div>
      </div>


      <br>
      <div>
        <h4>Current Documents</h4>
        <div>
          <div class="flex flex-row w-full">
            <span class="flex flex-col strong w-[40%]">File</span>
            <span class="flex flex-col strong w-[60%]">Requirement</span>
          </div>
            <div *ngFor="let document of license.licenseDocuments" class="flex flex-row">
            <span class="flex flex-col w-[40%]">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
            <span class="flex flex-col w-[60%]">
              <span *ngFor="let type of document.types">
                <span *ngFor="let docType of documentTypes">
                  <span *ngIf="docType.id == type"> {{docType.type}} </span>
                </span>
              </span>
            </span>
            </div>
        </div>
      </div>

      <br>

      <h3>Training Program Information</h3>
      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span class="text-wrap"><strong>Name of Training Program with OHA Approved Curriculum</strong></span>
          <span class="text-wrap">{{license.trainingProgram}}</span>
        </div>
      </div>
      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span class="text-wrap"><strong>Date Completed</strong></span>
          <span class="text-wrap">{{license.trainingDate | date}}</span>
        </div>
      </div>
      <div class="p-t-16 flex flex-row gap-4" *ngIf="sharedService.isAfterJan1st2027()">
        <div class="flex flex-col gap-2">
          <span class="text-wrap"><strong>Name of Training Program with Out-of-State Approved Curriculum</strong></span>
          <span class="text-wrap">{{license.oosTrainingProgram}}</span>
        </div>
      </div>
      <div class="p-t-16 flex flex-row gap-4" *ngIf="sharedService.isAfterJan1st2027()">
        <div class="flex flex-col gap-2">
          <span class="text-wrap"><strong>Date Completed</strong></span>
          <span class="text-wrap">{{license.oosTrainingDate | date}}</span>
        </div>
      </div>

      <div *ngIf="license.isRenewal" class="flex flex-col gap-4">
        <span class="text-wrap"><strong>Is all the information on this screen current and correct?</strong></span>
        <span class="text-wrap strong">Some information may be outdated or incorrect but you cannot change it on this application.
                    These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
                    If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</span>
        <span>{{license.documentPageCorrect ? 'Yes' : 'No'}}</span>

        <div class="p-t-16 flex flex-row gap-4" *ngIf="!license.documentPageCorrect">
          <div class="flex flex-col gap-2">
            <span class="text-wrap"><strong>Please list the information that is not current and correct</strong></span>

            <div class="flex flex-row gap-2">
              <span class="text-wrap">{{license.documentPageCorrectReason}}</span>
            </div>
            <div class="text-wrap">You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section.
              This is the first page you see when you log into TLC.</div>
          </div>
        </div>
      </div>
    </mat-card-content>

    <div class="page-break"></div>

    <mat-card-title *ngIf="!license.isRenewal">
      OHA Exam Page
    </mat-card-title>
    <mat-card-content *ngIf="!license.isRenewal" class="flex flex-col gap-4">
      <div><strong>Facilitator Exam</strong></div>
      <div>You have already passed the exam. Please continue through the application.</div>
      <div>You passed the exam on {{license.examDate | date:'MM/dd/yyyy'}}</div>
    </mat-card-content>

    <div class="page-break"></div>

    <mat-card-title>
      Fee Information Page
    </mat-card-title>
    <mat-card-content class="flex flex-col gap-4">
       <div class="flex flex-col gap-4">
        <span *ngIf="!license.isRenewal">Non-Refundable Facilitator Application Fee : $150.00</span>
        <span *ngIf="license.isRenewal">Non-Refundable Facilitator Renewal Application Fee: $2,000 or $1,000 if Applicant Qualifies for Reduced License Fee</span>

        <span style="white-space: pre-wrap" *ngIf="!license.isRenewal">
          The Facilitator application will not be reviewed until payment has been received and cleared. After the Facilitator application has been submitted, a “Pay Fee” button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.
        </span>
        <span style="white-space: pre-wrap" *ngIf="license.isRenewal">
          If your license application is approved, pending license fee payment and clearance, you will receive a request to pay the annual licensing fee. To request a reduced fee, please upload the required supporting document in the “Documents” tab of this application. If you qualify for a reduced license fee, the fee will be reduced accordingly. Please use the same payment instructions to pay the annual license fee.
          <br><br>Please Note: If payment is not submitted within 30 days from the date that you received notice that your renewal application has been moved to “renewal approved pending payment and clearance” status, your renewal application will be closed due to non-payment. The license will not be renewed until the payment has cleared and processing of the renewal has been completed.
          <br><br>
          After the application has been submitted and the review of the application has been completed and approved, a “Pay Fee” button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.
        </span>

        <span>Payment method options:</span>
        <ul>
          <li>Online</li>
          <li>Money Order</li>
          <li>Cashier's Check</li>
          <li>Personal/Business Check (personal and business checks are held for 21 days for clearance)</li>
          <li>Cash* <strong>Please Do Not Mail Cash</strong></li>
        </ul>

        <div *ngIf="!license.isRenewal" class="flex flex-row items-start">
          <span class="strong">Instructions for Submitting the Fee Payment by Mail or In-Person</span>
        </div>

        <div *ngIf="license.isRenewal" class="flex flex-row items-start">
          <span class="strong">Instructions for Submitting the Fee Payment by Mail or In-Person</span>
        </div>

        <span *ngIf="!license.isRenewal">
          Money orders and checks are payable to: &nbsp;<strong>Oregon Psilocybin Services</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Money orders and cashier's checks take less time to clear than personal and business checks.
          Personal and business checks are held for 21 days for clearance. Applications will be reviewed
          once payment has been cleared. Application fees are non-refundable.
        </span>

         <span *ngIf="license.isRenewal">
          Money orders and checks are payable to: &nbsp;<strong>Oregon Psilocybin Services</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Money orders and cashier's checks take less time to clear than personal and business checks.
          Personal and business checks are held for 21 days for clearance. Renewal license fees are non-refundable.
        </span>

        <div class="flex flex-col">
          <span>
            <strong *ngIf="!license.isRenewal">Mailing the application packet, money order or check, and remittance form:</strong>&nbsp;&nbsp;&nbsp;
            <strong *ngIf="license.isRenewal">Mailing the renewal application packet, money order or check, and remittance form:</strong>&nbsp;&nbsp;&nbsp;
          </span>
          <span>Oregon Health Authority - Public Health Division - Fiscal Services</span>
          <span>RE: OPS</span>
          <span>PO Box 14260</span>
          <span>Portland, OR 97293-0260</span>
        </div>

        <div class="flex flex-col">
          <span><strong>In-person payment with a money order or check:</strong></span>
          <span>
            To make an in-person fee payment with a money order or check, print the remittance form and proceed to
            Cashier's Office on the second floor of the Portland State Office Building at 800 NE Oregon St, Suite 200,
            Portland, OR 97232 - Hours: 9am to 4pm, Mon to Fri
          </span>
        </div>

        <span>
          Additional instructions: The Cashier's Office window is located on the second floor next to the Vital Health Statistics window.
          If security asks if you have an appointment, you may let them know you are dropping off a payment for Oregon Psilocybin Services
          at the Cashier's Office window which does not require an appointment. Please include the remittance form with the payment.
        </span>

        <div class="flex flex-col">
          <span><strong>To make cash payment arrangements or for payment questions, please contact:</strong></span>
          <div style="word-break: break-all; white-space: normal;" class="flex flex-row gap-2 justify-start items-center">

              <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                <span>
                  licensing.psilocybin&#64;oha.oregon.gov </span>
                <mat-icon>email</mat-icon>
              </div>

            <span>or Licensing Inquiries: 1-971-673-0304</span>
          </div>
        </div>

        <div *ngIf="!license.isRenewal" class="flex flex-col gap-4">
          <h3>Non-Refundable Facilitator Annual License Fee: $2,000 or $1,000 if Applicant Qualifies for Reduced License Fee:
          </h3>
          <span>
            If your license application is approved, pending license fee payment and clearance, you will receive a request to pay the annual licensing fee.
            Please review the guide for more detailed information on reduced fees. To request a reduced fee, please upload the required supporting document in
            the “Documents” tab of this application. If you qualify for a reduced license fee, the fee will be reduced accordingly. Please use the same payment instructions
            above to pay the annual license fee.
            <span class="strong">
              A license will not be issued until the annual license fee is paid and cleared. A licensee may not operate until the effective date of licensure.
            </span>
          </span>
        </div>


      </div>
    </mat-card-content>

    <div class="page-break"></div>

    <mat-card-title>Review and Submit Page
    </mat-card-title>
    <mat-card-content>
      <div><strong>Applicant Information</strong></div>
      <div class="p-b-16 flex flex-col gap-2">
        <div class="flex flex-col">
          <span class="w-[20%]"><strong>Legal Name</strong></span>&nbsp;&nbsp;&nbsp;
          <div class="w-[80%]">
            <span>{{license.applicants[0]?.legalFirstName}}</span>&nbsp;
            <span>{{license.applicants[0]?.legalMiddleName}}</span>&nbsp;
            <span>{{license.applicants[0]?.legalLastName}}</span>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="w-[20%]"><strong>Preferred Name</strong></span>&nbsp;&nbsp;&nbsp;
          <div class="flex flex-row gap-2 w-[80%]">
            <span>{{license.applicants[0]?.preferredFirstName}}</span>&nbsp;
            <span>{{license.applicants[0]?.preferredMiddleName}}</span>&nbsp;
            <span>{{license.applicants[0]?.preferredLastName}}</span>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="w-[20%]"><strong>Other Names</strong></span>&nbsp;&nbsp;&nbsp;
          <div class="flex flex-row gap-2 w-[80%]">
            <span>{{license.applicants[0]?.alternateNames}}</span>&nbsp;
          </div>
        </div>
        <div class="flex flex-col">
          <span class="w-[20%]"><strong>Physical Address</strong></span>&nbsp;&nbsp;
          <div class="flex flex-row gap-2 w-[80%]">
            <span>{{license.applicants[0]?.physicalStreet}}</span>&nbsp;
            <span>{{license.applicants[0]?.physicalCity}}</span>&nbsp;
            <span>{{license.applicants[0]?.physicalState}}</span>&nbsp;
            <span>{{license.applicants[0]?.physicalZip}}</span>&nbsp;
            <span>{{license.applicants[0]?.physicalCounty}}</span>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="w-[20%]"><strong>Mailing Address</strong></span>&nbsp;&nbsp;&nbsp;
          <div *ngIf="!license.applicants[0]?.mailingIsPhysical" class="flex flex-row gap-2 w-[80%]">
            <span>{{license.applicants[0]?.mailingStreet}}</span>&nbsp;
            <span>{{license.applicants[0]?.mailingCity}}</span>&nbsp;
            <span>{{license.applicants[0]?.mailingState}}</span>&nbsp;
            <span>{{license.applicants[0]?.mailingZip}}</span>&nbsp;
            <span>{{license.applicants[0]?.mailingCounty}}</span>
          </div>
          <div *ngIf="license.applicants[0]?.mailingIsPhysical" class="flex flex-row gap-2 w-[80%]">
            <span>Same as Physical</span>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="w-[20%]"><strong>Primary Phone</strong></span>&nbsp;&nbsp;&nbsp;
          <div class="flex flex-row gap-2 w-[80%]">
            <span>{{license.applicants[0]?.phone | mask: '(000) 000-0000 000000'}}</span>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="w-[20%]"><strong>Alternate Phone</strong></span>&nbsp;&nbsp;&nbsp;
          <div class="flex flex-row gap-2 w-[80%]">
            <span>{{license.applicants[0]?.alternatePhone | mask: '(000) 000-0000 000000'}}</span>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="w-[20%]"><strong>Email</strong></span>&nbsp;&nbsp;&nbsp;
          <div class="flex flex-row gap-2 w-[80%]">
            <span>{{license.applicants[0]?.email}}</span>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="w-[20%]"><strong>Language</strong></span>&nbsp;&nbsp;&nbsp;
          <div class="flex flex-row gap-2 w-[80%]">
            <span>{{license.applicants[0]?.language}}</span>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="w-[20%]"><strong>Training Program</strong></span>&nbsp;&nbsp;&nbsp;
          <span>{{license.trainingProgram}}</span>
        </div>

        <div class="flex flex-col">
          <span class="w-[20%]"><strong>Completed On:</strong></span>&nbsp;&nbsp;&nbsp;
          <span>{{license.trainingDate | date}}</span>
        </div>

        <div class="flex flex-col" *ngIf="sharedService.isAfterJan1st2027()">
          <span class="w-[20%]"><strong>Out-of-State Approved Training Program</strong></span>&nbsp;&nbsp;&nbsp;
          <span>{{license.oosTrainingProgram}}</span>
        </div>

        <div class="flex flex-col" *ngIf="sharedService.isAfterJan1st2027()">
          <span class="w-[20%]"><strong>Completed On:</strong></span>&nbsp;&nbsp;&nbsp;
          <span>{{license.oosTrainingDate | date}}</span>
        </div>

        <br>
        <div *ngIf="license.applicants[0]?.previousLicense" class="flex flex-col">
          <span>
            <span class="k-icon" [ngClass]="'k-i-checkbox-checked'"></span>
            <span class="text-wrap">Has this individual applied for or received any other licenses from Oregon Psilocybin Services?</span>
          </span>
          <div class="flex flex-col">
            <span>Previous Affiliated License</span>
            <span>{{license.applicants[0]?.affiliatedLicenses}}</span>
          </div>
        </div>

      </div>
    </mat-card-content>

    <mat-card-content>
      <div><strong>Current Documents</strong></div>
        <div class="flex flex-col gap-2">
          <div class="flex flex-row">
            <span class="w-[60%]"><strong>File</strong></span>&nbsp;&nbsp;
            <span><strong>Requirement</strong></span>
          </div>
          <div *ngFor="let document of license.applicants[0]?.applicantDocuments" class="flex flex-row">
            <span class="text-indigo-A700 w-[60%]">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
            <div class="flex flex-col">
              <div *ngFor="let type of document.types" class="flex flex-row">
                {{documentTypeReference[type]}}
              </div>
            </div>
          </div>
          <div *ngFor="let document of license?.licenseDocuments" class="flex flex-row">
            <span class="text-indigo-A700 w-[60%]">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
            <div class="flex flex-col">
              <div *ngFor="let type of document.types" class="flex flex-row">
                {{documentTypeReference[type]}}
              </div>
            </div>
          </div>
        </div>
    </mat-card-content>

    <mat-card-content>
        <div><strong>Facilitator Exam</strong></div>
        <div class="flex flex-col gap-2">
          <div class="flex flex-row gap-2">
            <span class="w-[30%]"><strong>Score</strong></span>&nbsp;&nbsp;&nbsp;
            <span class="w-[30%]"><strong>Result</strong></span>&nbsp;&nbsp;&nbsp;
            <span class="w-[40%]"><strong>Date Taken</strong></span>&nbsp;&nbsp;&nbsp;
          </div>
          <div *ngFor="let attempt of license.examAttempts" class="flex flex-row gap-2">
            <span class="w-[30%]">{{attempt.score}}%</span>
            <span *ngIf="attempt.passed" class="w-[30%]"><strong>Passed</strong></span>&nbsp;&nbsp;&nbsp;
            <span *ngIf="!attempt.passed" class="w-[30%]">Failed</span>
            <span class="w-[40%]">{{attempt.dateTaken | date}}</span>
          </div>
        </div>
    </mat-card-content>

    <mat-card-content class="flex flex-col gap-4">
      <div><strong>Signature and Acknowledgements</strong></div>
      <div class="flex flex-col gap-2">
        <ul class="p-l-24">
          <li>
          I certify the information provided in this application is true and complete to the best of my knowledge.
          I understand falsifying an application, supplying misleading information, or withholding information is grounds for denial of my application or revocation of my license.
        </li>
        <li>
          I understand I am responsible for making my own determination regarding the legal risks associated with a Schedule 1 substance
          under the Federal Controlled Substances Act.
        </li>
        <li>
          I understand the information provided in application materials, including applicant name, is subject to disclosure
          under Oregon's public records laws and that certain information may be posted on OHA's website for purposes of license verification.
        </li>
        <li>
          I understand the following information in the application will be used by Oregon Psilocybin Services to start the background check process:
          legal name; date of birth; physical address; phone number; email address; proof of identity; prior addresses if lived out of state during the
          past five years; social security number (if consented); and prior names and aliases.
        </li>
        <li> I understand I must complete and pass a background check as a condition of licensure.
        </li>
        <li>
          I understand I must notify Oregon Psilocybin Services in writing within 10 business days of any conviction for any misdemeanor or felony committed
          and I will be required to undergo another criminal background check.
        </li>
        <li> I understand I must notify Oregon Psilocybin Services in writing within 10 business days of a change in contact information.
        </li>
        <li> I understand I am also required to obtain a worker permit as described in OAR 333-333-4070.
        </li>
        <li>
          I have read, understand, and agree to adhere to the Oregon Psilocybin Services Revised Statutes (ORS) Chapter 475A,
          Oregon Administrative Rules (OAR) Chapter 333, Division 333, as well as any other applicable statutes or laws.
        </li>
        <li>
          I understand that failure to adhere to these statutes and rules may result in a denial of my application or disciplinary action if
          I am licensed by Oregon Psilocybin Services.
        </li>
        <li>
          I understand the psilocybin facilitator license has a term of one year from the effective date of licensure.
          If I wish to renew my license after that term, I understand I must complete a renewal application.
        </li>
        <li>
          I understand a license will not be issued until the license fee payment is paid and cleared.
          A licensee may not operate until the effective date of licensure.
        </li>
        <li *ngIf="!license.isRenewal"> Applicant(s) understand and will comply with the requirement to complete and submit the Required 303 Applicant and Licensee REAL & SOGI
          Data form in accordance with ORS 475A.374.
        </li>
        <li>I understand the psilocybin facilitator application and annual license fees are non-refundable.
        </li>
        </ul>

        <span>
          <span class="k-icon" [ngClass]="license.attestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I have read and I understand the above statements</span>
        </span>
      </div>

      <div class="page-break"></div>

      <div class="flex flex-col gap-4">
        <div class="flex flex-row">
          <span>
            <span class="k-icon"  [ngClass]="license.directoryConsent ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
            <span class="text-wrap">I consent to having my license name, license type, and the contact information selected below listed in the voluntary OPS Licensee Directory.</span>
          </span>
        </div>
        <br>
        <div>Please select which contact information you would like to include in the directory:</div>


        <div style="padding-left: 1em" *ngIf="license.directoryConsent" class="flex flex-col">
           <div class="gap-[5px]">
            <span>
              <span class="k-icon"  [ngClass]="license.directoryPreferredName ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">Display my preferred name in the License Directory instead of my legal name.</span>
            </span>
          </div>

          <div class="gap-[5px]">
            <span>
              <span class="k-icon"  [ngClass]="license.directoryConsentWebsite ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">Website: {{license.directoryWebsite}}</span>
            </span>
          </div>

          <div class="gap-[5px]">
            <span>
              <span class="k-icon"  [ngClass]="license.directoryConsentEmail ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">Email: {{license.directoryEmail}}</span>
            </span>
          </div>

          <div class="gap-[5px]">
            <span>
              <span class="k-icon"  [ngClass]="license.directoryConsentPhone ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">Phone Number: {{license.directoryPhone}}</span>
            </span>
          </div>
        </div>

        <div class="flex flex-row">
          <span>
            <span class="k-icon"  [ngClass]="!license.directoryConsent ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
            <span class="text-wrap">I <strong>do not </strong>&nbsp; consent to having my license name, license type, and contact information listed in the voluntary OPS Licensee Directory.</span>
          </span>
        </div>
      </div>
      <span class="text-wrap"><em>Please note, if you do not consent, you may still be licensed with Oregon Psilocybin Services.</em></span>

      <div class="flex flex-col lg:flex-row gap-2 justify-start items-center">
        <span>Signature: {{license.electronicSignature}}</span>
      </div>
    </mat-card-content>
  </mat-card>
</div>
